import React, { useEffect, useState, useCallback } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Row,
  Col,
  Label,
  Alert,
} from 'reactstrap';
import Select from 'react-select';
import { Async } from 'react-select';
import { TimePicker } from 'antd';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { BoldText, RegularText } from '../common/Text';
import { FaEdit } from 'react-icons/fa';

import {
  getVerticals,
  searchDoctors,
  shiftAppointment,
  getDoctorSlots as getDocSlots,
  confirmRequest,
} from '../../services/api/offline-consult';

import moment from 'moment';
import LoadingComponent from '../../components/common/LoadingComponent';

const EDIT_APPOINTMENT_REASONS = [
  { reason: '', label: 'Select Reason' },
  { reason: 'Doctor is in emergency', label: 'Doctor is in emergency' },
  { reason: 'Slot not available', label: 'Slot not available' },
  { reason: 'Consultation fee changed', label: 'Consultation fee changed' },
  {
    reason: 'User requested for alternate slot',
    label: 'User requested for alternate slot',
  },
  {
    reason: 'Doctor sits in multiple branches',
    label: 'Doctor sits in multiple branches',
  },
  {
    reason: 'Doctor moved to the other branch',
    label: 'Doctor moved to the other branch',
  },
  {
    reason: 'Doctor on leave',
    label: 'Doctor on leave',
  },
  {
    reason: 'Doctor is out of station',
    label: 'Doctor is out of station',
  },
  {
    reason: 'Doctor is not available as per the requested slots',
    label: 'Doctor is not available as per the requested slots',
  },
];

const SectionInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.625rem;
`;

const SectionHeader = styled(BoldText)`
  font-size: 1.2rem;
  color: #4b4f5b;
`;

const SectionBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 0.625rem;
`;
const Warning = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 0.625rem;
  padding-top: 1rem;
  color: #ffaf3c;
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 0.25rem;
`;

const DetailName = styled.div`
  font-size: 1rem;
  width: ${(props) => (props.fullWidth ? '20rem' : '8rem')};
  color: #4c4c4c;
`;

const DoctorSlotBox = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`;

const DetailText = styled(RegularText)`
  flex: 1;
  font-size: 1rem;
  color: ${(props) => props.color || '#787778'};
  margin-left: 0.25rem;
`;

const RescheduleAppointMentRequest = (props) => {
  const {
    shiftingDetails,
    isOpen,
    closeShiftingModal,
    fetchTableData,
    showEditDoctorSlotsModal,
    showEditDoctorSlots,
  } = props;
  console.log(props);
  const [selectedVertical, setSelectedVertical] = useState({});
  const [allVerticals, setAllVerticals] = useState([]);
  const [requestId, setRequestId] = useState('');
  const [verticalLoading, setVerticalLoading] = useState(false);
  const [doctorsData, setDoctorsData] = useState([]);
  const [appDate, setAppDate] = useState('');
  const [dateKey, setDateKey] = useState('');
  const [selectedSlot, setSelectedSlot] = useState('');
  const [appointmentStartTime, setAppointmentStartTime] = useState(null);
  const [appointmentEndTime, setAppointmentEndTime] = useState(null);
  const [centerAddress, setCenterAddress] = useState(null);
  const [editReason, setEditReason] = useState('');
  const [editComment, setEditComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [slotType, setSlotType] = useState('fixed');
  const [warning, setWarning] = useState('');
  const [doctorSlots, setDoctorSlots] = useState(null);
  const [showDoctorNewSlots, setShowDoctorNewSlots] = useState(false);
  const [externalSlotInfo, setExternalSlotInfo] = useState(null);
  const [doctorNewSlot, setDoctorNewSlot] = useState({
    modal: false,
    data: [],
    date: ''
  });
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [verificationChecks, setVerificationChecks] = useState({
    specializationVerified: false,
    feeVerified: false,
    paymentDetailsVerified: false,
    branchAddressVerified: false,
  });

  const checkWhetherApptDateWithinSlots = useCallback((date, valueModified = false) => {
    let isWithinSlots = false;
    const apptDate = new Date(date);
    const apptDOW = apptDate.getDay() + 1;
    const apptTime = moment(apptDate).format('HH:mm:ss');
    console.log('checkWhetherApptDateWithinSlots', {
      date,
      apptDate,
      apptDOW,
      apptTime,
    });
    const apptFormatDate = moment(date).format('YYYY-MM-DD')
    console.log('checkWhetherApptDateWithinSlots', { date, apptDate, apptDOW, apptTime, apptFormatDate});
    const correctSlots = !showDoctorNewSlots ? doctorSlots.filter(slot => slot.dow === apptDOW) : doctorSlots.filter(slot => slot.formattedDateKey === apptFormatDate);
    console.log('checkWhetherApptDateWithinSlotsData', { correctSlots});

    if(!showDoctorNewSlots){
    for (let slot of correctSlots) {
      for (let slotValue of slot.values) {
        const startTime = moment(slotValue.startTime, 'hh:mm A').format(
          'HH:mm:ss'
        );
        const endTime = moment(slotValue.endTime, 'hh:mm A').format('HH:mm:ss');
        if (apptTime >= startTime && apptTime <= endTime) isWithinSlots = true;
      }
    }}
    else{
      if(correctSlots[0] && correctSlots[0].slots){
        for(let slotValue of correctSlots[0].slots) {
        const startTime = moment(slotValue.slotKey, 'hh:mm A').format('HH:mm:ss');
        const endTime = moment(slotValue.slotKeyEndTime, 'hh:mm A').format('HH:mm:ss');
        if(apptTime >= startTime && apptTime <= endTime){
          isWithinSlots = true;
          if(slotValue.externalSlotInfo){
            setExternalSlotInfo({...slotValue.externalSlotInfo})  
          }
        }
      }
    }}
    setWarning(
      !isWithinSlots
        ? 'The selected Appointment Date/Time is not within the Available Doctor Slots, edit the slots or select different date/time'
        : ''
    );
    if (!isWithinSlots && valueModified) {
      toast.error(
        'The selected Appointment Date/Time is not within the Available Doctor Slots, edit the slots or select different date/time'
      );
      setDoctorSlots(null);
      if(!showDoctorNewSlots){
        showEditDoctorSlotsModal(shiftingDetails.doctorId);
      }
    }
    return isWithinSlots;
  }, [doctorSlots, showDoctorNewSlots, shiftingDetails, showEditDoctorSlotsModal]);

  const getDoctorSlots = useCallback(
    (doctorId, networkCenterId) => {
      let { requestId } = shiftingDetails;
      if (doctorId && networkCenterId) {
        requestId = null;
      }

      getDocSlots({ requestId, doctorId, networkCenterId })
        .then((res) => {
          console.log({ slots: res.data, showSlot: res.data.showSlot }, 'getDoctorSlots');
          setLoading(true);
          if(res.data.showSlot){
            setSlotType('walk-in');
          }
          else{
            setSlotType('fixed');
        }
          setShowDoctorNewSlots(res.data.showSlot);  
          setDoctorSlots(res.data.slots);
          checkWhetherApptDateWithinSlots(shiftingDetails.uAppointmentDate);
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => setLoading(false))
    },
    [checkWhetherApptDateWithinSlots, shiftingDetails]
  );

  useEffect(() => {
    if (shiftingDetails && allVerticals && allVerticals.length > 0) {
      console.log(shiftingDetails);
      setRequestId(shiftingDetails.requestId);
      const vertical = allVerticals.find(
        (item) => item.value == shiftingDetails.verticalId
      );
      setSelectedVertical(vertical);
    }
    if (shiftingDetails && shiftingDetails.doctorId) {
      setDoctorsData({
        label: `${shiftingDetails.doctorName} - ${shiftingDetails.networkCenterName} - ${shiftingDetails.networkCenterAddress}`,
        value: shiftingDetails.doctorId,
        centerId: shiftingDetails.networkCenterId,
        fees: shiftingDetails.total_charges,
      });
    }
    if (shiftingDetails && shiftingDetails.uAppointmentDate) {
      console.log(shiftingDetails,'shigtiksk')
      const date = shiftingDetails.uAppointmentDate.split(' ')[0];
      setAppDate(date);
      const dateKey = moment(date, 'YYYY-MM-DD').format('YYYYMMDD');
      setDateKey(dateKey);
    }
    if(shiftingDetails && shiftingDetails.networkCenterAddress){
      setCenterAddress(shiftingDetails.networkCenterAddress);
    }
  }, [shiftingDetails, allVerticals]);

  useEffect(() => {
    fetchVerticals();
  }, []);

  useEffect(() => {
    if (isOpen && shiftingDetails?.doctorId && shiftingDetails?.networkCenterId) {
      getDoctorSlots();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, showEditDoctorSlots]);

  const fetchVerticals = () => {
    setVerticalLoading(true);
    getVerticals().then((response) => {
      const arr = [];
      response.data.forEach((element) => {
        arr.push({ value: element.verticalId, label: element.verticalName });
      });
      setAllVerticals(arr);
      setVerticalLoading(false);
    });
  };

  const searchDoctor = (val) => {
    const verticalId = selectedVertical.value;
    return searchDoctors(val, verticalId, null, null, doctorsData.centerId || null)
      .then((response) => {
        return response.data || [];
      })
      .then((result) =>
        result.map((ele) => {
          return {
            label: `${ele.doctorName} - ${ele.networkCenterTitle} - ${ele.centerCity} - ${ele.networkSourceName}`,
            value: ele.doctorId,
            centerId: ele.networkCenterId,
            fees: ele.opdCharges,
            centerAddress: ele.centerAddress
          };
        })
      )
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDateChange = (event) => {
    const date = event.target.value;
    if (!date) {
      return;
    }
    const dateKey = moment(date, 'YYYY-MM-DD').format('YYYYMMDD');
    setAppDate(date);
    console.log(date);
    setDateKey(dateKey);
  };

  const shiftAppointments = async (shiftAndConfirm = false) => {
    setLoading(true);
    const { requestId,sponsorId } = shiftingDetails;
    try {
      const doctorId = doctorsData.value || false;
      const centerId = doctorsData.centerId || false;
      if (!doctorId || !centerId || !editReason || !dateKey || !selectedSlot) {
        toast.error('Incorrect Selection');
        setLoading(false);
        return;
      }
      if (slotType === 'walk-in' && !(appointmentStartTime || appointmentEndTime)) {
        toast.error('Incorrect Selection');
        setLoading(false);
        return;
      }
      const slotCheckResult = checkWhetherApptDateWithinSlots(
        `${appDate} ${slotType === 'fixed' ? selectedSlot : appointmentStartTime}`
      );
      if (!slotCheckResult) {
        toast.error(
          'The selected Appointment Date/Time is not within the Available Doctor Slots, edit the slots or select different date/time'
        );
        setLoading(false);
        return;
      }
      let timeRange =
        appointmentStartTime && appointmentEndTime && slotType == 'walk-in'
          ? `${appointmentStartTime}-${appointmentEndTime}`
          : null;

      const shiftResponse = await shiftAppointment(
        requestId,
        doctorId,
        centerId,
        editReason,
        editComment,
        dateKey,
        selectedSlot,
        slotType,
        timeRange,
        externalSlotInfo,
        shiftAndConfirm,
        false,
        '',
        sponsorId
      );
  
      if (shiftResponse.message === 'success') {
        if (shiftAndConfirm) {
          try {
            // Wait for confirm request to complete
            await confirmRequest(
              requestId,
              dateKey,
              selectedSlot,
              false,
              slotType,
              timeRange,
              shiftAndConfirm
            );
            
            // Only close modal and show success if both operations succeed
            closeShiftingModal();
            toast.success('Appointment shifted and confirmed successfully');
            fetchTableData();
          } catch (error) {
            console.error('Error in confirmRequest:', error);
            toast.error(`Appointment rescheduled successfully, but confirmation failed`);
            // Don't close modal on confirmation error
          }
        } else {
          // If just shifting (no confirmation needed), close modal and show success
          closeShiftingModal();
          toast.success('Appointment shifted successfully');
          fetchTableData();
        }
      } else {
        const err = new Error('Invalid response');
        err.data = shiftResponse;
        throw err;
      }
    } catch (err) {
      console.log({ err, response: err.response?.data });
      toast.error(`Failure! ${err.response?.data?.errorMessage || err.data?.errorMessage || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const hanldeVerticalChange = (vertical) => {
    setSelectedVertical(vertical);
  };

  const handleDoctorSelection = (doctorsData) => {
    console.log(doctorsData,'doctorsData123')
    setDoctorsData(doctorsData);
    getDoctorSlots(doctorsData.value, doctorsData.centerId);
    setCenterAddress(doctorsData.centerAddress);
  };

  const handleVerificationCheckChange = (checkName) => {
    setVerificationChecks(prevState => ({
      ...prevState,
      [checkName]: !prevState[checkName]
    }));
  };

  const areAllVerificationsChecked = () => {
    return Object.values(verificationChecks).every(check => check === true);
  };

  const handleInitialShiftAndConfirm = () => {
    const doctorId = doctorsData.value || false;
    const centerId = doctorsData.centerId || false;
    if (!doctorId || !centerId || !editReason || !dateKey || !selectedSlot) {
      toast.error('Incorrect Selection');
      return;
    }
    if (slotType === 'walk-in' && !(appointmentStartTime || appointmentEndTime)) {
      toast.error('Incorrect Selection');
      return;
    }
    const slotCheckResult = checkWhetherApptDateWithinSlots(
      `${appDate} ${slotType === 'fixed' ? selectedSlot : appointmentStartTime}`
    );
    if (!slotCheckResult) {
      toast.error(
        'The selected Appointment Date/Time is not within the Available Doctor Slots, edit the slots or select different date/time'
      );
      return;
    }
    // Open verification modal
    setShowVerificationModal(true);
  };

  const handleFinalConfirm = async () => {
    if (!areAllVerificationsChecked()) {
      toast.error('Please verify all items before confirming');
      return;
    }
    setShowVerificationModal(false);
    await shiftAppointments(true);
    // Reset verification checks after successful confirmation
    setVerificationChecks({
      specializationVerified: false,
      feeVerified: false,
      paymentDetailsVerified: false,
      branchAddressVerified: false,
    });
  };

  const closeVerificationModal = () => {
    setShowVerificationModal(false);
  };

  console.log('sgasgabnk', shiftingDetails);

  return (
    <>
    <Modal
      //   onOpened={this.onModalOpened}
      centered
      isOpen={isOpen}
      onCancel={closeShiftingModal}
      toggle={closeShiftingModal}
    >
      <ModalHeader className="revamp-modal-header" toggle={closeShiftingModal}>
        Reschedule Request ({requestId})
      </ModalHeader>
      <ModalBody>
        <form>
          <FormGroup>
          {showDoctorNewSlots && <Warning>{'The appointment rescheduled request for this centre will be auto confirmed since it is API driven, please ensure patient is aligned for this slot before rescheduling.'}</Warning>}
            <Row style={{marginTop: '16px'}}>
              <Col className="col-3" style={{}}>
                <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '500',
                    width: 'max-content',
                  }}
                >
                  Select Vertical:
                </Label>
              </Col>
              <Col>
                <Select
                  className="dynamic-select"
                  isSearchable={true}
                  onChange={(e) => {
                    hanldeVerticalChange(e);
                  }}
                  value={selectedVertical}
                  options={allVerticals}
                  isLoading={verticalLoading}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col className="col-3">
                <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '500',
                    width: 'max-content',
                  }}
                >
                  Search Doctor:
                </Label>
              </Col>
              <Col>
                <Async
                  loadOptions={searchDoctor}
                  onChange={(e) => {
                    handleDoctorSelection(e);
                  }}
                  value={doctorsData}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col className="col-3">
                <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '500',
                    width: 'max-content',
                  }}
                >
                  Center Address:
                </Label>
              </Col>
              <Col>
              <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '300',
                    padding:'4px'
                  }}
                >
                  {centerAddress ?  centerAddress : 'Unavailable'}
                </Label>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col className="col-3">
                <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '500',
                    width: 'max-content',
                  }}
                >
                  Consultation Fee:
                </Label>
              </Col>
              <Col>
                <input
                  className="form-control"
                  style={{
                    backgroundColor: '#FAFBFC',
                    borderRadius: '15px',
                    cursor: 'not-allowed',
                  }}
                  type="number"
                  value={doctorsData.fees}
                  disabled
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col
                className="col-3"
                style={{
                  borderRadius: '15px',
                }}
              >
                <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '500',
                    width: 'max-content',
                  }}
                >
                  Appointment Date:
                </Label>
              </Col>
              <Col>
                <input
                  className="form-control"
                  type="date"
                  value={appDate}
                  onChange={handleDateChange}
                  style={{ borderRadius: '15px' }}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col style={{ borderRadius: '15px' }} className="col-3">
                <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '500',
                  }}
                >
                  Slot type:
                </Label>
              </Col>
              <Col>
                <select
                  value={slotType}
                  onChange={(e) => {
                    setSlotType(e.target.value);
                  }}
                  className="form-control"
                >
                { !showDoctorNewSlots &&  <option value="fixed" key="fixed">
                    Fixed
                  </option>
                 }
                  <option value="walk-in" key="walk-in">
                    Walk In
                  </option>
                </select>
              </Col>
            </Row>
          </FormGroup>
          {slotType == 'fixed' && (
            <FormGroup>
              <Row>
                <Col style={{ borderRadius: '15px' }} className="col-3">
                  <Label
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: '500',
                      width: 'max-content',
                    }}
                  >
                    Appointment Time:
                  </Label>
                </Col>
                <Col>
                  <TimePicker
                    className="w-full"
                    onChange={(_, date) => {
                      setSelectedSlot(date);
                      if (appDate && date) {
                        checkWhetherApptDateWithinSlots(
                          `${appDate} ${date}`,
                          true
                        );
                      }
                    }}
                    format="hh:mm:00 A"
                    defaultValue={
                      selectedSlot
                        ? moment(selectedSlot, 'hh:mm:00 A')
                        : undefined
                    }
                  />
                </Col>
              </Row>
            </FormGroup>
          )}
          {slotType == 'walk-in' && (
            <FormGroup>
              <Row>
                <Col style={{ borderRadius: '15px' }} className="col-3">
                  <Label
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: '500',
                      width: 'max-content',
                    }}
                  >
                    Appointment Time:
                  </Label>
                </Col>
                <Col className="col-4">
                  <TimePicker
                    className="w-full"
                    onChange={(_, date) => {
                      console.log(date);
                      const newTime =
                        date.substring(0, 3) +
                        date.substring(3, 5) +
                        ' ' +
                        date.substring(9);
                      setAppointmentStartTime(newTime);
                      setSelectedSlot(date);
                      if (appDate && date) {
                        checkWhetherApptDateWithinSlots(
                          `${appDate} ${date}`,
                          true
                        );
                      }
                    }}
                    placeholder="Start Time"
                    format="hh:mm:00 A"
                    defaultValue={
                      appointmentStartTime
                        ? moment(appointmentStartTime, 'hh:mm:00 A')
                        : undefined
                    }
                  />
                </Col>
                <Col className="col-4">
                  <TimePicker
                    className="w-full"
                    onChange={(_, date) => {
                      const newTime =
                        date.substring(0, 3) +
                        date.substring(3, 5) +
                        ' ' +
                        date.substring(9);
                      setAppointmentEndTime(newTime);
                    }}
                    format="hh:mm:00 A"
                    placeholder="End Time"
                    defaultValue={
                      appointmentEndTime
                        ? moment(appointmentEndTime, 'hh:mm:00 A')
                        : undefined
                    }
                  />
                </Col>
              </Row>
            </FormGroup>
          )}
          <FormGroup>
            <Row>
              <Col style={{ borderRadius: '15px' }} className="col-3">
                <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '500',
                    width: 'max-content',
                  }}
                >
                  Reschedule Reason:
                </Label>
              </Col>
              <Col>
                <select
                  value={editReason}
                  onChange={(e) => {
                    setEditReason(e.target.value);
                  }}
                  className="form-control"
                >
                  {EDIT_APPOINTMENT_REASONS.map(({ reason, label }) => (
                    <option value={reason} key={reason}>
                      {label}
                    </option>
                  ))}
                </select>{' '}
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col style={{ borderRadius: '15px' }} className="col-3">
                <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '500',
                    fontSize: '17px',
                  }}
                >
                  Remarks
                </Label>
              </Col>
              <Col>
                <textarea
                  className="form-control"
                  value={editComment}
                  rows={1}
                  onChange={(e) => setEditComment(e.target.value)}
                />
              </Col>
            </Row>
          </FormGroup>
        </form>
        {warning && <Warning>{warning}</Warning>}
        {doctorSlots ? (
          <SectionInnerContainer>
            <SectionHeader>
              Doctor Slots &nbsp;
              { !showDoctorNewSlots && <FaEdit
                className="button"
                onClick={() => {
                  setDoctorSlots(null);
                  showEditDoctorSlotsModal(doctorsData.value);
                }}
              />}
            </SectionHeader>
            <SectionBody>
            {!loading && !showDoctorNewSlots && doctorSlots.map((slot) => (
                <DetailRow key={slot.day}>
                  <DetailName>{`${slot.day}:`}</DetailName>
                  <DetailText>
                    {slot.values
                      .map((value) => `${value.startTime} - ${value.endTime}`)
                      .join(', ')}
                  </DetailText>
                </DetailRow>
              ))}

            {!loading && showDoctorNewSlots && doctorSlots.map((slot) => (
                  <DetailRow key={slot.dateKey}>
                    <DetailName>{`${slot.formattedDateKey}:`}</DetailName>
                    <DetailText>
                      {slot.slots.slice(0,4)
                        .map((value) => `${value.timings}`)
                        .join(', ')} { slot.slots.length > 4 && <span style={{ color: 'green', cursor: 'pointer', fontWeight: 700}} onClick={() => setDoctorNewSlot({modal: true, data: slot.slots, date: slot.formattedDateKey})}>...more</span>}
                    </DetailText>
                  </DetailRow>
                ))}
            </SectionBody>
          </SectionInnerContainer>
        ) : (
          <Button color="link" onClick={ () => getDoctorSlots(doctorsData.value, doctorsData.centerId)}>
            Show Doctor Slots
          </Button>
        )}
        <Modal
            isOpen={doctorNewSlot.modal}
            onCancel={() => setDoctorNewSlot({ modal: false, data: [] })}
          >
  <ModalHeader
    className="bg-primary"
    toggle={() => setDoctorNewSlot({ modal: false, data: [] })}
  >
    Doctor Slots
  </ModalHeader>
  <ModalBody>
    <DetailRow>
      <DetailName>{`${doctorNewSlot.date}:`}</DetailName>
      <DoctorSlotBox>
        {doctorNewSlot.data.map((value) => (
          <p
            style={{
              padding: "6px",
              backgroundColor: "skyblue",
              borderRadius: "8px",
              margin: "4px",
            }}
          >
            {value.timings}
          </p>
        ))}
      </DoctorSlotBox>
    </DetailRow>
  </ModalBody>
</Modal>
      </ModalBody>
      <ModalFooter
        style={{
          display: 'flex',
          justifyContent: 'space-around',
        }}
      >
        {loading ? <LoadingComponent color={'black'} /> : <>
        <Button
          style={{ backgroundColor: '#714FFF', width : '29%' }}
          disabled={loading || !selectedSlot || !editReason || !dateKey}
          onClick={() => shiftAppointments(false)}
        >
          Shift Appointment
        </Button>
        <Button 
          style={{
            backgroundColor: '#714FFF',
            border: '1px solid #714FFF',
            width : '33%' 
          }}
          disabled={loading || !selectedSlot || !editReason || !dateKey}
          onClick={handleInitialShiftAndConfirm}
        >
          Shift And Confirm
        </Button>
        <Button
          style={{
            backgroundColor: '#FFFFFF',
            color: '#714FFF',
            border: '1px solid #714FFF',
            width : '33%' 
          }}
          onClick={() => closeShiftingModal()}
        >
          Close
        </Button>
        </>}
      </ModalFooter>
    </Modal>

    {/* Verification Modal */}
    <Modal
      isOpen={showVerificationModal}
      toggle={closeVerificationModal}
      centered
    >
      <ModalHeader toggle={closeVerificationModal}>
        Verify Appointment Details
      </ModalHeader>
      <ModalBody>
        <div style={{ padding: '10px' }}>
          <p style={{ marginBottom: '20px', color: '#4b4f5b', fontWeight: '500' }}>
            Please verify the following before confirming the appointment:
          </p>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input
                type="checkbox"
                id="specializationVerified"
                checked={verificationChecks.specializationVerified}
                onChange={() => handleVerificationCheckChange('specializationVerified')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <label 
                htmlFor="specializationVerified" 
                style={{ margin: 0, cursor: 'pointer', fontSize: '14px' }}
              >
                Specialization Verified
              </label>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input
                type="checkbox"
                id="feeVerified"
                checked={verificationChecks.feeVerified}
                onChange={() => handleVerificationCheckChange('feeVerified')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <label 
                htmlFor="feeVerified" 
                style={{ margin: 0, cursor: 'pointer', fontSize: '14px' }}
              >
                Fee Verified
              </label>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input
                type="checkbox"
                id="paymentDetailsVerified"
                checked={verificationChecks.paymentDetailsVerified}
                onChange={() => handleVerificationCheckChange('paymentDetailsVerified')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <label 
                htmlFor="paymentDetailsVerified" 
                style={{ margin: 0, cursor: 'pointer', fontSize: '14px' }}
              >
                Payment Details Verified
              </label>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input
                type="checkbox"
                id="branchAddressVerified"
                checked={verificationChecks.branchAddressVerified}
                onChange={() => handleVerificationCheckChange('branchAddressVerified')}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <label 
                htmlFor="branchAddressVerified" 
                style={{ margin: 0, cursor: 'pointer', fontSize: '14px' }}
              >
                Branch / Address Verified
              </label>
            </div>
          </div>

          {!areAllVerificationsChecked() && (
            <div style={{ 
              marginTop: '15px', 
              padding: '10px', 
              backgroundColor: '#fff3cd',
              borderRadius: '4px',
              border: '1px solid #ffc107',
              color: '#856404',
              fontSize: '13px'
            }}>
              All verifications must be checked to confirm the appointment.
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter
        style={{
          display: 'flex',
          justifyContent: 'space-around',
        }}
      >
        <Button
          style={{
            backgroundColor: 'rgb(113, 79, 255)',
            width: '40%',
            borderColor: 'rgb(113, 79, 255)',
            height: '44px',
          }}
          onClick={handleFinalConfirm}
          disabled={!areAllVerificationsChecked() || loading}
        >
          Confirm Appointment
        </Button>
        <Button
          style={{
            backgroundColor: 'rgb(255, 255, 255)',
            width: '40%',
            borderColor: 'rgb(113, 79, 255)',
            color: 'rgb(113, 79, 255)',
            height: '44px',
          }}
          onClick={closeVerificationModal}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  </>
  );
};

export default RescheduleAppointMentRequest;
